import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53803bc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "amazon-tip-content flex-center"
}
const _hoisted_2 = { class: "fx-1" }

import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: ['title', 'keyValue'],
  setup(__props) {

const props = __props

const store = useStore()
const show = ref(false)
const curShop = computed(() => store.state.route.curShop)
onMounted(() => {
  const storage = Number(JSON.parse((localStorage.getItem(props.keyValue) ?? '{}'))?.[curShop.value] ?? 0)
  var now = new Date().setHours(0, 0, 0, 0)
  show.value = now - storage > 0
})
const close = () => {
  const obj:any = {}
  obj[curShop.value] = String(new Date().getTime())
  localStorage.setItem(props.keyValue, JSON.stringify(obj))
  show.value = false
}

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1),
        _createElementVNode("img", {
          src: "https://static-s.theckb.com/BusinessMarket/icon/fba/close_icon.png",
          alt: "",
          onClick: close
        })
      ]))
    : _createCommentVNode("", true)
}
}

})